import React, { Component } from 'react'
import moment from 'moment';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { development } from "../../libs/utils/Const";



class BankDeposit extends Component {

    render() {
        const { DocHeader, DocLines, reprint, user, time } = this.props
        return (
            <table><tr><td>
                <div id="printInvoice" >
                    <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }}>

                        <div className="row">
                            <div className="col-3">
                                <img src={development ? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                                <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /></p>
                            </div>
                            <div className="col-6 text-center">
                                <h5><strong>DEPÓSITOS BANCARIOS</strong></h5>
                            </div>
                            <div className="col-3">

                            </div>
                        </div>
                        <div className='row mt-4' style={{ paddingRight: "15px" }}>
                        <label className="text-center" style={{fontSize: "14px"}}>{reprint?<><strong>REIMPRESION: </strong>{user.U_NAME} {time}</>:""}</label>
                            <table>
                                <thead>
                                    <tr>
                                        {/* <th className="text-left" colSpan="2">DEL 07/08/2022 AL 28/08/2022</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        {/* <td><strong>RESPONSABLE: </strong>{user ? user. : ''}</td> */}
                                    </tr>
                                    <tr>
                                        <td><strong>VENTA TOTAL: </strong>{DocHeader && DocHeader.docTotal ? CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.docTotal) : ''}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>FECHA: </strong>{DocHeader && DocHeader.docDate ? moment(DocHeader.docDate).format("YYYY-MM-DD") : ''}</td>

                                    </tr>
                                </tbody>
                            </table>
                            <table className='mt-3'>
                                <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                    <tr>
                                        <th className="text-left">Documento No.</th>
                                        <th className="text-left">Forma de pago</th>
                                        <th className="text-left">Cuenta destino</th>
                                        <th className="text-center">Moneda</th>
                                        <th className="text-right">Importe ML</th>
                                        <th className="text-right">Deposito real</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                                        DocLines.map((docLine, index) => {

                                            return (
                                                <tr style={{ fontSize: '12px' }}>
                                                    <td>{index}</td>
                                                    <td>{docLine && docLine.origin ? docLine.origin : ''}</td>
                                                    <td>{docLine && docLine.destiny ? docLine.destiny : ''}</td>
                                                    <td className="text-center">{CURRENCY ?? ''}</td>
                                                    <td className="text-right">{docLine && docLine.amount ? CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.amount) : ''}</td>
                                                    <td className='text-right'>{docLine && docLine.amount ? CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.amount) : ''}</td>
                                                </tr>
                                            );

                                        })
                                    }

                                </tbody>
                            </table>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-8'>

                                <p>
                                    <strong>Comentario general:</strong><br />
                                    {DocHeader && DocHeader.comment ? DocHeader.comment : ''}
                                    Comentarios por movimiento:<br/>
                                    {DocHeader && DocHeader.comments.length > 0 &&
                                        DocHeader.comments.map((comment, index) => {
                                            return (
                                                <div className='row'>
                                                    <p><strong>Documento No.</strong> {index} Comentario: {comment || ''}</p>
                                                </div>
                                            );
                                        })
                                    }
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                </p>
                            </div>
                            <div className='col-4'>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className='text-right'><strong>Total: </strong></td>
                                            <td className='text-right'>{DocHeader && DocHeader.docTotal ? CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.docTotal) : ''}</td>
                                        </tr>
                                        <tr>
                                            {/* <td className='text-right'><strong>Diferencia cambiaría: </strong></td> */}
                                            {/* <td className='text-right'>{SYMBOL + FORMAT_NUMBER.new(0) + ' ' + CURRENCY}</td> */}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </td></tr></table>

        )
    }
}

export default BankDeposit